import { FieldDefinition } from '../types/FieldDefinition';

/**
 * Returns the global id for a fieldDefinition. This takes into account
 * compositeGlobals where the field might have multiple globals attached, and
 * will concat their ids together
 * @param fieldDef
 */
export function getFieldGlobalId(fieldDef: FieldDefinition) {
  if (!fieldDef.global && !fieldDef.compositeGlobal) {
    return null;
  }

  if (fieldDef.global) {
    return fieldDef.global.id;
  }

  const ids = fieldDef.compositeGlobal?.globals?.map((global) => global.id);

  return ids?.join(':');
}
